// Route-Level Preloading für instant Navigation
export const preloadRoute = (routePath: string) => {
  // Dynamically import the route to trigger Vite's code splitting preload
  switch (routePath) {
    case '/cyberrisiken':
      import('../pages/CyberRisks');
      break;
    case '/faq':
      import('../pages/FAQ');
      break;
    case '/tarifwissen':
      import('../pages/Tarifwissen');
      break;
    case '/weitere-versicherungen':
      import('../pages/WeitereVersicherungen');
      break;
    case '/erstinformation':
      import('../pages/Erstinformation');
      break;
    case '/termin-buchen':
      import('../pages/TerminBuchen');
      break;
  }
};
